<template>
    <div style="margin: 0 auto;width: 1190px;">
        <!-- 轮播 -->
        <div class="m-index-banner" id="indexBanner">
            <div class="g-wrapper-new">
                <div class="ibanner-container">
                    <div class="ibanner-main g-clearfix" style="position: relative;">
                        <swiper :options="swiperOption" ref="mySwiper" style="width: 100%; height: 100%;">
                            <!-- slides -->
                            <swiper-slide v-for="(item, key) in banner" :key="key">
                                <a>
                                    <img :src="item.image" style="width: 100%; height: 100%;" />
                                </a>
                            </swiper-slide>
                            <!-- Optional controls -->
                            <div class="swiper-pagination" slot="pagination"></div>
                            <div class="swiper-button-prev swiper-button-black" slot="button-prev"></div>
                            <div class="swiper-button-next swiper-button-black" slot="button-next"></div>
                        </swiper>
                    </div>
                </div>
            </div>
        </div>

        <div class="ifloor-wrap" id="indexFloor_0">
            <template v-for="(i, key1) in dataList">
                <div class="m-floor-column" :key="key1" v-if="i.BrandList.length > 0">
                    <div class="floor-col2">
                        <div class="m-floor-item" style="flex-direction: row;display: flex;">
                            <div class="floor-title">
                                <a :href="'/search?CategoryID=' + i.CategoryID" class="bg" :title="i.Name">
                                    <img :src="img[key1]" />
                                </a>
                                <div class="nav-list">
                                    <template v-for="(item, key) in i.BrandList">
                                        <a
                                            :key="key"
                                            v-if="key < 8"
                                            :href="'search?BrandID=' + item.BrandID"
                                            target="_blank"
                                            :title="item.Name"
                                            >{{ item.Name }}</a
                                        >
                                    </template>
                                </div>
                            </div>
                            <div style="width: calc(100% - 250px); height: 100%; flex-direction: column;display: flex;">
                                <div style="height: 40px;width: 100%;">
                                    <div
                                        class="m-tabs-header cols-3"
                                        style="display: flex;justify-content: flex-start;align-items: center;"
                                    >
                                        <template v-for="(j, key2) in i.BrandList">
                                            <template v-if="key2 < 9">
                                                <a
                                                    v-if="key2 == 0"
                                                    :key="key2"
                                                    @mouseenter="tabsSwitch(key1, key2, i.CategoryID, j.BrandID)"
                                                    :title="j.Name"
                                                    :href="'/search?CategoryID=' + i.CategoryID + '&BrandID=' + j.BrandID"
                                                    class="tab-item on"
                                                >
                                                    <span class="name">{{ j.Name }}</span>
                                                </a>
                                                <a
                                                    v-else
                                                    :key="key2"
                                                    @mouseenter="tabsSwitch(key1, key2, i.CategoryID, j.BrandID)"
                                                    :title="j.Name"
                                                    :href="'/search?CategoryID=' + i.CategoryID + '&BrandID=' + j.BrandID"
                                                    class="tab-item"
                                                >
                                                    <span class="name">{{ j.Name }}</span>
                                                </a>
                                            </template>
                                        </template>
                                        <div class="tab-item title-more">
                                            <a :href="'/search?CategoryID=' + i.CategoryID" style="color: white;">
                                                <div>
                                                    更多
                                                    <img src="../assets/images/more.png" height="20px" alt="" />
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div style="height: 500px; width: 100%; display: flex; flex-direction: row;">
                                    <div class="tabs-container" floor-tabs-container>
                                        <template v-for="(j, key2) in i.BrandList">
                                            <template v-if="isLoading">
                                                <div
                                                    v-if="key2 < 9"
                                                    class="tab-content"
                                                    :style="{
                                                        display: key2 == 0 ? 'block' : 'none'
                                                    }"
                                                    :key="key2"
                                                >
                                                    <template v-for="(item, key) in goodsList[key1][key2]">
                                                        <a
                                                            class="m-floor-goods"
                                                            v-if="key < 12"
                                                            :href="'/ProcInfo?sku=' + item.SKU"
                                                            target="_blank"
                                                            :key="key"
                                                        >
                                                            <div class="pic">
                                                                <img
                                                                    v-lazy="
                                                                        'http://mallmgr.cesseon.com/api/Shop/GetImageSize?width=156&height=250&name=' +
                                                                            item.PicName +
                                                                            '&type=1'
                                                                    "
                                                                />
                                                            </div>
                                                            <div class="info">
                                                                <p class="name" :title="item.Name">
                                                                    {{ item.Name }}
                                                                </p>
                                                                <!-- <p class="price">￥{{ (item.StandPrice / 100).toFixed(2) }}</p> -->
                                                                <p class="price" v-if="item.IsCustProduct">
                                                                    ￥{{ (item.Price / 100).toFixed(2) }}
                                                                </p>
                                                                <p class="price" v-else>￥????</p>
                                                            </div>
                                                        </a>
                                                    </template>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import { GlobalFun } from '@/common/utils';
import { IndexApi } from '../common/api';
export default {
    name: 'index',
    data() {
        return {
            banner: [
                {
                    image: require('../assets/banner/1.jpg'),
                    url: 'search?CategoryID=14'
                },
                {
                    image: require('../assets/banner/2.jpg'),
                    url: 'search?CategoryID=12'
                },
                {
                    image: require('../assets/banner/3.jpg'),
                    url: 'search?CategoryID=5'
                }
            ],
            swiperOption: {
                notNextTick: true,
                //循环
                loop: true,
                //设定初始化时slide的索引
                initialSlide: 0,
                //自动播放
                autoplay: true,
                // autoplay: {
                //   delay: 800,
                //   stopOnLastSlide: true,
                //   disableOnInteraction: true
                // },
                //滑动速度
                speed: 800,
                //滑动方向
                direction: 'horizontal',
                //小手掌抓取滑动
                grabCursor: false,
                //滑动之后回调函数
                on: {
                    slideChangeTransitionEnd: function() {
                        // console.log(this.activeIndex);//切换结束时，告诉我现在是第几个slide
                    }
                },
                //左右点击
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                //分页器设置
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                }
            },
            swiperSlides: [1, 2, 3, 4, 5],

            //分页信息
            pageSize: 4,
            pageIndex: 0,
            pageCount: 11,
            innerPageCount: 1,
            pageTotal: 0,

            keyword: '',
            brandID: '',
            categoryID: '',
            dataList: [],
            img: [
                require('@/assets/index/0.jpg'),
                require('@/assets/index/1.jpg'),
                require('@/assets/index/2.jpg'),
                require('@/assets/index/3.jpg'),
                require('@/assets/index/4.jpg'),
                require('@/assets/index/5.jpg'),
                require('@/assets/index/6.jpg'),
                require('@/assets/index/7.jpg'),
                require('@/assets/index/8.jpg'),
                require('@/assets/index/9.jpg'),
                require('@/assets/index/10.jpg'),
                require('@/assets/index/11.jpg'),
                require('@/assets/index/12.jpg'),
                require('@/assets/index/13.jpg'),
                require('@/assets/index/14.jpg'),
                require('@/assets/index/15.jpg')
            ],

            goodsList: new Object(),
            isLoading: false
        };
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper;
        }
    },
    async mounted() {
        this.isLoading = false;
        this.dataList = await IndexApi.GetAllCategory();
        this.goodsList = new Array(this.dataList.length);
        for (let i = 0; i < this.dataList.length; i++) {
            this.goodsList[i] = new Array();
        }
        for (let i = 0; i < this.dataList.length; i++) {
            if (this.dataList[i].BrandList.length > 0) {
                this.goodsList[i][0] = await IndexApi.GetProductSKUByCategory(
                    this.dataList[i].CategoryID,
                    this.dataList[i].BrandList[0].BrandID
                );
            }
        }
        this.isLoading = true;
    },
    methods: {
        async tabsSwitch(el, index, CategoryID, BrandID) {
            //盒子元素下标 元素下标 品牌ID
            $('.m-tabs-header')
                .eq(el)
                .find('a')
                .not(index)
                .removeClass('on')
                .eq(index)
                .addClass('on');

            $('.tabs-container')
                .eq(el)
                .find('.tab-content')
                .not(index)
                .hide()
                .eq(index)
                .show();
            if (this.goodsList[el][index] == undefined) {
                this.goodsList[el][index] = [];
            }
            if (this.goodsList[el][index].length == 0) {
                this.goodsList[el][index] = await IndexApi.GetProductSKUByCategory(CategoryID, BrandID);
                this.$forceUpdate();
            }
        }
    },

    components: {
        swiper,
        swiperSlide
    }
};
</script>

<style>
@import url('../assets/css/index.css');

.m-floor-goods:nth-child(6),
.m-floor-goods:nth-child(12) {
    border-right: 1px solid #e8e8e8;
}
.m-floor-goods:nth-child(7),
.m-floor-goods:nth-child(8),
.m-floor-goods:nth-child(9),
.m-floor-goods:nth-child(10),
.m-floor-goods:nth-child(11),
.m-floor-goods:nth-child(12) {
    border-bottom: 1px solid #e8e8e8;
}

.tabs-container,
.tab-content {
    width: 100%;
    height: 500px;
}
.title-more div {
    background: #fb5772;
    display: flex;
    align-items: center;
    margin-right: 10px;
}
.title-more {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 12px;
    cursor: pointer;
    color: #ffffff;
    justify-content: flex-end;
    flex: 1;
    min-width: 60px;
}
</style>
